function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.3 2.25a.8.8 0 00-1.6 0v.7H8.3v-.7a.8.8 0 10-1.6 0v.7H4.5A1.55 1.55 0 002.95 4.5v15c0 .856.694 1.55 1.55 1.55h15a1.55 1.55 0 001.55-1.55v-15a1.55 1.55 0 00-1.55-1.55h-2.2zm2.15 5.2v-2.9H17.3v.7a.8.8 0 01-1.6 0v-.7H8.3v.7a.8.8 0 01-1.6 0v-.7H4.55v2.9zm-14.9 1.6h14.9v10.4H4.55z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgCalendar;